//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Icons Import */

import dayjs from 'dayjs';
import { PropTypes } from 'prop-types';
// import SAT_BASIC_1Function from '../SAT_BASIC_01/SAT_BASIC_01F';
import SAT_BASIC_3Function from '../SAT_BASIC_03/SAT_BASIC_03F';
// import SAT_BASIC_4Function from '../SAT_BASIC_04/SAT_BASIC_04F';
import SAT_BASIC_5Function from '../SAT_BASIC_05/SAT_BASIC_05F';
import SAT_BASIC_6Function from '../SAT_BASIC_06/SAT_BASIC_06F';
import SAT_BASIC_7Function from '../SAT_BASIC_07/SAT_BASIC_07F';
import TRA_CUSTOM_2Function from '../../MultiTrainingPage/TRA_CUSTOM_02/TRA_CUSTOM_02F';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchText, setYear } from '../../../../Reducer/SearchReducer';
//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <React.Fragment>
      {value === index && (
        <Box sx={{ width: '100%', height: '100%', minHeight: 0 }}>
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function SAT_BASIC(props) {
  //#region 변수
  // const gridRef7 = useRef(); // 안전보건총괄책임자(도급)
  const dispatch = useDispatch();

  const searchInfo = useSelector((state) => state.SearchInfo);
  //#endregion
  //#region 웹

  //#endregion
  //#region 함수

  //#endregion
  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="SafetyHealthTraining"
          searchYn="Y"
          addYn={props.value === 0 || props.value === 2 ? 'N' : 'Y'}
          saveYn="Y"
          deleteYn={props.value === 0 || props.value === 2 ? 'N' : 'Y'}
          //printYn={props.value !== 1 ? 'Y' : 'N'}
          printYn={'Y'}
          addClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setAddClick3(true); // 연간교육 계획표
            } else if (props.value === 1) {
              props.setAddClick2(true); // 교육일지 (TRA_CUSTOM_2Function)
            } else if (props.value === 2) {
              props.setAddClick5(true); // 교육이수현황
            } else if (props.value === 3) {
              props.setAddClick6(true); // 교육별
            } else if (props.value === 4) {
              props.setAddClick7(true); // 대상별
            } else if (props.value === 5) {
              props.setAddClick6(true);
            } else if (props.value === 6) {
              props.setAddClick7(true);
            }
          }}
          searchClick={(e) => {
            if (!props.validateSelection()) return;
            dispatch(setSearchText(e));
            if (props.value === 0) {
              props.setFilterClick3(true); // 연간교육 계획표
            } else if (props.value === 1) {
              props.setFilterClick2(true); // 교육일지 (TRA_CUSTOM_2Function)
            } else if (props.value === 2) {
              props.setFilterClick5(true); // 교육이수현황
            } else if (props.value === 3) {
              props.setFilterClick6(true); // 교육별
            } else if (props.value === 4) {
              props.setFilterClick7(true); // 대상별
            } else if (props.value === 5) {
              props.setFilterClick6(true);
            } else if (props.value === 6) {
              props.setFilterClick7(true);
            }
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setSaveClick3(true); // 연간교육 계획표
            } else if (props.value === 1) {
              props.setSaveClick2(true); // 교육일지 (TRA_CUSTOM_2Function)
            } else if (props.value === 2) {
              props.setSaveClick5(true); // 교육이수현황
            } else if (props.value === 3) {
              props.setSaveClick6(true); // 교육별
            } else if (props.value === 4) {
              props.setSaveClick7(true); // 대상별
            } else if (props.value === 5) {
              props.setSaveClick6(true);
            } else if (props.value === 6) {
              props.setSaveClick7(true);
            }
          }}
          deleteClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setDeleteClick3(true); // 연간교육 계획표
            } else if (props.value === 1) {
              props.setDeleteClick2(true); // 교육일지 (TRA_CUSTOM_2Function)
            } else if (props.value === 2) {
              props.setDeleteClick5(true); // 교육이수현황
            } else if (props.value === 3) {
              props.setDeleteClick6(true); // 교육별
            } else if (props.value === 4) {
              props.setDeleteClick7(true); // 대상별
            } else if (props.value === 5) {
              props.setDeleteClick6(true);
            } else if (props.value === 6) {
              props.setDeleteClick7(true);
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setPrintClick3(true); // 연간교육 계획표
            } else if (props.value === 1) {
              props.setPrintClick2(true); // 교육일지 (TRA_CUSTOM_2Function)
            } else if (props.value === 2) {
              props.setPrintClick5(true); // 교육이수현황
            } else if (props.value === 3) {
              props.setPrintClick6(true); // 교육별
            } else if (props.value === 4) {
              props.setPrintClick7(true); // 대상별
            } else if (props.value === 5) {
              props.setPrintClick6(true);
            } else if (props.value === 6) {
              props.setPrintClick7(true);
            }
          }}
          conditions={
            props.value === 0
              ? [
                  {
                    type: 'datePicker',
                    views: ['year'],
                    openTo: 'year',
                    title: '기간',
                    name: '조회연도',
                    value: dayjs(searchInfo.year, 'YYYY'),

                    onChange: async (date) => {
                      if (date) {
                        let changeYear = dayjs(date).format('YYYY'); // 연도만 저장
                        dispatch(setYear(changeYear));
                        if (props.value === 0) {
                          await props.setSearchClick3(true); // 연간교육 계획표
                        }
                      }
                    },
                    currentLocale: 'ko',
                    format: 'YYYY', // 연도만 출력되게
                  },
                  // ADMIN이면 추가 combo
                  ...(props.userInfo.authCd === 'ADMIN'
                    ? [
                        {
                          type: 'combo',
                          name: '회사',
                          items: searchInfo.coList,
                          value: searchInfo.coCd,
                          onChange: async (e) => {
                            await props.handleCoChange(e);

                            if (props.value === 0) {
                              await props.setSearchClick3(true); // 연간교육 계획표
                            } else if (props.value === 1) {
                              await props.setSearchClick2(true); // 교육일지
                            } else if (props.value === 2) {
                              await props.setSearchClick5(true); // 교육이수현황
                            } else if (props.value === 3) {
                              await props.setSearchClick6(true); // 교육별
                            } else {
                              await props.setSearchClick7(true); // 대상별
                            }
                          },
                        },
                      ]
                    : []),
                  {
                    type: 'combo',
                    name: '사업장',
                    items: searchInfo.custList,
                    value: searchInfo.custCd,
                    onChange: async (e) => {
                      await props.handleCustChange(e);

                      if (props.value === 0) {
                        await props.setSearchClick3(true); // 연간교육 계획표
                      } else if (props.value === 1) {
                        await props.setSearchClick2(true); // 교육일지 (TRA_CUSTOM_2Function)
                      } else if (props.value === 2) {
                        await props.setSearchClick5(true); // 교육이수현황
                      } else if (props.value === 3) {
                        await props.setSearchClick6(true); // 교육별
                      } else {
                        await props.setSearchClick7(true); // 대상별
                      }
                    },
                  },
                ]
              : props.value === 1
                ? [
                    {
                      type: 'datePicker',
                      title: '기간',
                      name: '교육일시(시작)',
                      value: dayjs(props.startDate),
                      onChange: async (date) => {
                        props.handleStartDateChange(date);

                        if (props.value === 1) {
                          await props.setSearchClick2(true); // 교육자료 탭
                        }
                      },
                      currentLocale: 'ko',
                    },
                    {
                      type: 'datePicker',
                      title: '기간',
                      name: '교육일시(끝)',
                      value: dayjs(props.endDate),
                      onChange: async (date) => {
                        props.handleEndDateChange(date);

                        if (props.value === 1) {
                          await props.setSearchClick2(true); // 교육자료 탭
                        }
                      },
                      currentLocale: 'ko',
                    },
                    // ADMIN이면 추가 combo
                    ...(props.userInfo.authCd === 'ADMIN'
                      ? [
                          {
                            type: 'combo',
                            name: '회사',
                            items: searchInfo.coList,
                            value: searchInfo.coCd,
                            onChange: async (e) => {
                              await props.handleCoChange(e);

                              if (props.value === 0) {
                                await props.setSearchClick3(true); // 연간교육 계획표
                              } else if (props.value === 1) {
                                await props.setSearchClick2(true); // 교육일지
                              } else if (props.value === 2) {
                                await props.setSearchClick5(true); // 교육이수현황
                              } else if (props.value === 3) {
                                await props.setSearchClick6(true); // 교육별
                              } else {
                                await props.setSearchClick7(true); // 대상별
                              }
                            },
                          },
                        ]
                      : []),
                    {
                      type: 'combo',
                      name: '사업장',
                      items: searchInfo.custList,
                      value: searchInfo.custCd,
                      onChange: async (e) => {
                        await props.handleCustChange(e);

                        if (props.value === 0) {
                          await props.setSearchClick3(true); // 연간교육 계획표
                        } else if (props.value === 1) {
                          await props.setSearchClick2(true); // 교육일지 (TRA_CUSTOM_2Function)
                        } else if (props.value === 2) {
                          await props.setSearchClick5(true); // 교육이수현황
                        } else if (props.value === 3) {
                          await props.setSearchClick6(true); // 교육별
                        } else {
                          await props.setSearchClick7(true); // 대상별
                        }
                      },
                    },
                  ]
                : props.value === 2
                  ? [
                      {
                        type: 'datePicker',
                        views: ['year'],
                        openTo: 'year',
                        title: '기간',
                        name: '조회연도',
                        value: searchInfo.searchYear
                          ? dayjs(searchInfo.searchYear, 'YYYY')
                          : dayjs(),
                        onChange: async (date) => {
                          if (date) {
                            let changeYear = dayjs(date).format('YYYY');
                            props.searchRef.current = {
                              ...props.searchRef.current,
                              searchYear: changeYear,
                            };
                            if (props.value === 2) {
                              await props.setSearchClick5(true); // 교육이수현황
                            }
                          }
                        },
                        currentLocale: 'ko',
                        format: 'YYYY',
                      },
                      // ADMIN이면 추가 combo
                      ...(props.userInfo.authCd === 'ADMIN'
                        ? [
                            {
                              type: 'combo',
                              name: '회사',
                              items: searchInfo.coList,
                              value: searchInfo.coCd,
                              onChange: async (e) => {
                                await props.handleCoChange(e);

                                if (props.value === 2) {
                                  await props.setSearchClick5(true); // 교육이수현황
                                }
                              },
                            },
                          ]
                        : []),
                      {
                        type: 'combo',
                        name: '사업장',
                        items: searchInfo.custList,
                        value: searchInfo.custCd,
                        onChange: async (e) => {
                          await props.handleCustChange(e);

                          if (props.value === 2) {
                            await props.setSearchClick5(true); // 교육이수현황
                          }
                        },
                      },
                    ]
                  : props.value === 3 || props.value === 4
                    ? [
                        {
                          type: 'datePicker',
                          views: ['year'],
                          openTo: 'year',
                          title: '기간',
                          name: '조회연도',
                          value: searchInfo.searchYear
                            ? dayjs(searchInfo.searchYear, 'YYYY')
                            : dayjs(),
                          onChange: async (date) => {
                            if (date) {
                              let changeYear = dayjs(date).format('YYYY');
                              props.searchRef.current = {
                                ...props.searchRef.current,
                                searchYear: changeYear,
                              };
                              if (props.value === 3) {
                                await props.setSearchClick6(true); // 교육별
                              } else if (props.value === 4) {
                                await props.setSearchClick7(true); // 대상별
                              }
                            }
                          },
                          currentLocale: 'ko',
                          format: 'YYYY',
                        },
                        // ADMIN이면 추가 combo
                        ...(props.userInfo.authCd === 'ADMIN'
                          ? [
                              {
                                type: 'combo',
                                name: '회사',
                                items: searchInfo.coList,
                                value: searchInfo.coCd,
                                onChange: async (e) => {
                                  await props.handleCoChange(e);

                                  if (props.value === 3) {
                                    await props.setSearchClick6(true); // 교육별
                                  } else if (props.value === 4) {
                                    await props.setSearchClick7(true); // 대상별
                                  }
                                },
                              },
                            ]
                          : []),
                        {
                          type: 'combo',
                          name: '사업장',
                          items: searchInfo.custList,
                          value: searchInfo.custCd,
                          onChange: async (e) => {
                            await props.handleCustChange(e);

                            if (props.value === 3) {
                              await props.setSearchClick6(true); // 교육별
                            } else if (props.value === 4) {
                              await props.setSearchClick7(true); // 대상별
                            }
                          },
                        },
                      ]
                    : [
                        {
                          type: 'datePicker',
                          title: '기간',
                          name: '교육일시(시작)',
                          value: dayjs(props.startDate),
                          onChange: async (date) => {
                            props.handleStartDateChange(date);

                            if (props.value === 0) {
                              await props.setSearchClick2(true); // 교육일지
                            } else if (props.value === 1) {
                              await props.setSearchClick3(true); // 연간교육 계획표
                            } else if (props.value === 2) {
                              await props.setSearchClick5(true); // 교육이수현황
                            } else if (props.value === 3) {
                              await props.setSearchClick6(true); // 교육별
                            } else {
                              await props.setSearchClick7(true); // 대상별
                            }
                          },
                          currentLocale: 'ko',
                        },
                        {
                          type: 'datePicker',
                          title: '기간',
                          name: '교육일시(끝)',
                          value: dayjs(props.endDate),
                          onChange: async (date) => {
                            props.handleEndDateChange(date);

                            if (props.value === 0) {
                              await props.setSearchClick2(true); // 교육일지
                            } else if (props.value === 1) {
                              await props.setSearchClick3(true); // 연간교육 계획표
                            } else if (props.value === 2) {
                              await props.setSearchClick5(true); // 교육이수현황
                            } else if (props.value === 3) {
                              await props.setSearchClick6(true); // 교육별
                            } else {
                              await props.setSearchClick7(true); // 대상별
                            }
                          },
                          currentLocale: 'ko',
                        },
                        // ADMIN이면 추가 combo
                        ...(props.userInfo.authCd === 'ADMIN'
                          ? [
                              {
                                type: 'combo',
                                name: '회사',
                                items: searchInfo.coList,
                                value: searchInfo.coCd,
                                onChange: async (e) => {
                                  await props.handleCoChange(e);

                                  if (props.value === 0) {
                                    await props.setSearchClick3(true); // 연간교육 계획표
                                  } else if (props.value === 1) {
                                    await props.setSearchClick2(true); // 교육일지
                                  } else if (props.value === 2) {
                                    await props.setSearchClick5(true); // 교육이수현황
                                  } else if (props.value === 3) {
                                    await props.setSearchClick6(true); // 교육별
                                  } else {
                                    await props.setSearchClick7(true); // 대상별
                                  }
                                },
                              },
                            ]
                          : []),
                        {
                          type: 'combo',
                          name: '사업장',
                          items: searchInfo.custList,
                          value: searchInfo.custCd,
                          onChange: async (e) => {
                            await props.handleCustChange(e);

                            if (props.value === 0) {
                              await props.setSearchClick2(true); // 교육일지
                            } else if (props.value === 1) {
                              await props.setSearchClick3(true); // 연간교육 계획표
                            } else if (props.value === 2) {
                              await props.setSearchClick5(true); // 교육이수현황
                            } else if (props.value === 3) {
                              await props.setSearchClick6(true); // 교육별
                            } else {
                              await props.setSearchClick7(true); // 대상별
                            }
                          },
                        },
                      ]
          }
          grids={
            <React.Fragment>
              <Box>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="basic tabs example"
                >
                  {/* <Tab
                    label="교육현황"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  /> */}
                  <Tab
                    label="연간교육 계획표"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="교육일지"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="교육이수현황"
                    {...A11yProps(2)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="교육관리(교육별)"
                    {...A11yProps(3)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="교육관리(대상자별)"
                    {...A11yProps(4)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  {/* <Tab
                    {...A11yProps(3)}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <span
                          style={{
                            fontSize: '0.95rem',
                            fontWeight: 'bold',
                            color: '#000',
                            whiteSpace: 'nowrap', // ✅ 교육자료는 무조건 한줄
                          }}
                        >
                          교육자료
                        </span>
                        {props.value === 3 && (
                          <Box
                            sx={{
                              ml: 1,
                              backgroundColor: '#fff8e1',
                              px: 1,
                              borderRadius: '4px',
                              border: '1px solid #ffe082',
                              color: '#e65100',
                              fontWeight: 500,
                              fontSize: '0.75rem',
                              maxWidth: 250, // ✅ 원하는 너비 제한
                              whiteSpace: 'normal', // ✅ 2줄 허용
                              lineHeight: 1.2, // ✅ 줄간격 조금 줄임
                            }}
                          >
                            * 교육자료를 다중 소속에 일괄 등록할 경우 오른쪽{' '}
                            <u>추가버튼</u>을 이용해주세요.
                          </Box>
                        )}
                      </Box>
                    }
                  /> */}
                  {/* <Tab
                    label="교육자료"
                    {...A11yProps(3)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  /> */}
                  {/* {props.value === 3 && (
                    <Box
                      sx={{
                        mt: 1,
                        mb: 1,
                        ml: 3,
                        backgroundColor: '#fff8e1',
                        padding: '6px 10px',
                        borderRadius: '4px',
                        border: '1px solid #ffe082',
                        color: '#e65100',
                        fontWeight: '500',
                        fontSize: '0.85rem',
                      }}
                    >
                      * 교육자료를 다중 소속에 일괄 등록할 경우 오른쪽 <u>추가버튼</u>을 이용해주세요.
                    </Box>
                  )} */}
                </Tabs>
              </Box>

              {/* <CustomTabPanel value={props.value} index={0}>
                <SAT_BASIC_1Function
                  searchRef={props.searchRef}
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel> */}
              {/* 연간교육 계획표 */}
              <CustomTabPanel value={props.value} index={0}>
                <SAT_BASIC_3Function
                  filterClick3={props.filterClick3}
                  setFilterClick3={props.setFilterClick3}
                  searchClick3={props.searchClick3}
                  setSearchClick3={props.setSearchClick3}
                  addClick3={props.addClick3}
                  setAddClick3={props.setAddClick3}
                  saveClick3={props.saveClick3}
                  setSaveClick3={props.setSaveClick3}
                  deleteClick3={props.deleteClick3}
                  setDeleteClick3={props.setDeleteClick3}
                  printClick3={props.printClick3}
                  setPrintClick3={props.setPrintClick3}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              {/* 교육일지 */}
              <CustomTabPanel value={props.value} index={1}>
                <TRA_CUSTOM_2Function
                  filterClick2={props.filterClick2}
                  setFilterClick2={props.setFilterClick2}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  addClick2={props.addClick2}
                  setAddClick2={props.setAddClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  deleteClick2={props.deleteClick2}
                  setDeleteClick2={props.setDeleteClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              {/* 교육이수현황 */}
              <CustomTabPanel value={props.value} index={2}>
                <SAT_BASIC_5Function
                  filterClick5={props.filterClick5}
                  setFilterClick5={props.setFilterClick5}
                  searchClick5={props.searchClick5}
                  setSearchClick5={props.setSearchClick5}
                  addClick5={props.addClick5}
                  setAddClick5={props.setAddClick5}
                  saveClick5={props.saveClick5}
                  setSaveClick5={props.setSaveClick5}
                  deleteClick5={props.deleteClick5}
                  setDeleteClick5={props.setDeleteClick5}
                  printClick5={props.printClick5}
                  setPrintClick5={props.setPrintClick5}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              {/* 교육관리(교육별) */}
              <CustomTabPanel value={props.value} index={3}>
                <SAT_BASIC_6Function
                  searchRef={props.searchRef}
                  filterClick6={props.filterClick6}
                  setFilterClick6={props.setFilterClick6}
                  searchClick6={props.searchClick6}
                  setSearchClick6={props.setSearchClick6}
                  addClick6={props.addClick6}
                  setAddClick6={props.setAddClick6}
                  saveClick6={props.saveClick6}
                  setSaveClick6={props.setSaveClick6}
                  deleteClick6={props.deleteClick6}
                  setDeleteClick6={props.setDeleteClick6}
                  printClick6={props.printClick6}
                  setPrintClick6={props.setPrintClick6}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              {/* 교육관리(대상자별) */}
              <CustomTabPanel value={props.value} index={4}>
                <SAT_BASIC_7Function
                  searchRef={props.searchRef}
                  filterClick7={props.filterClick7}
                  setFilterClick7={props.setFilterClick7}
                  searchClick7={props.searchClick7}
                  setSearchClick7={props.setSearchClick7}
                  addClick7={props.addClick7}
                  setAddClick7={props.setAddClick7}
                  saveClick7={props.saveClick7}
                  setSaveClick7={props.setSaveClick7}
                  deleteClick7={props.deleteClick7}
                  setDeleteClick7={props.setDeleteClick7}
                  printClick7={props.printClick7}
                  setPrintClick7={props.setPrintClick7}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              {/* <CustomTabPanel value={props.value} index={3}>
                <SAT_BASIC_4Function
                  searchRef={props.searchRef}
                  filterClick4={props.filterClick4}
                  setFilterClick4={props.setFilterClick4}
                  searchClick4={props.searchClick4}
                  setSearchClick4={props.setSearchClick4}
                  addClick4={props.addClick4}
                  setAddClick4={props.setAddClick4}
                  saveClick4={props.saveClick4}
                  setSaveClick4={props.setSaveClick4}
                  deleteClick4={props.deleteClick4}
                  setDeleteClick4={props.setDeleteClick4}
                  printClick4={props.printClick4}
                  setPrintClick4={props.setPrintClick4}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel> */}
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default SAT_BASIC;
